import React from 'react';

export const TextFilter: React.ComponentType<{
  onChange: (values: string[]) => void;
  value?: string[];
}> = ({ onChange, value = [] }) => {
  return (
    <>
    </>
  );
};
